require('../vendor/jquery.flexslider.js');

(function(window){

	const $ = require('jquery');

	$(document).ready(function(){

		$('.flexslider-enquiry').flexslider({
			directionNav: false,
			controlNav: true
		});

		$('.flexslider-projects').flexslider({
			directionNav: false,
			controlNav: true
		})
		
		$(".flexslider-gallery").flexslider({
			directionNav: false,
			controlNav: true
		});

	});

})(window);
